import Head from '../Head/Head'
import Footer from '../../components/Footer/Footer'

const Blogs = () => {
    return (
        <div>
            <Head />
            <section className="heading_banner contactusBackground" >
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                            <h1 className="cat_title">Blogs</h1>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='news_section blog_page mt-1'>
                <div className='container'>
                    <h2 className="clrLogo aboutTitle mb-5">Our Blogs</h2>
                    <div className="clearfix"></div>
                    <div className='row gap_y'>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 events-full-box">
                            <div className="events-single-box">
                                <div className="row">
                                    <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                        <a href="/blogCardDetail" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">
                                            <img className="img-responsive" src="https://www.ukgermanpharmaceuticals.com/uploaded-files/blog/images/thumbs/How-To-Choose-The-Best-Animal-Health-Companies-In-India-For-Livestock-Management-thumbs-250X250.jpg" alt="img" />

                                        </a>
                                    </div>

                                    <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">
                                        <div className="event-info">
                                            <h4 className="title_h4"><a href="https://www.ukgermanpharmaceuticals.com/blog/how-to-choose-the-best-animal-health-companies-in-india-for-livestock-management.htm" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">How To Choose The Best Animal Health Companies In India For Livestock Management?</a></h4>

                                            <p className='lineClamp4'>Choosing the appropriate animal health company for livestock management is important for the health and productivity of your animals. India has a </p>


                                            <a className="event-btn" href="/blogCardDetail" title="Read More">Read More<i className="fa fa-long-arrow-right events-btn-icon"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 events-full-box">
                            <div className="events-single-box">
                                <div className="row">
                                    <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                        <a href="/blogCardDetail" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">
                                            <img className="img-responsive" src="https://www.ukgermanpharmaceuticals.com/uploaded-files/blog/images/thumbs/How-To-Choose-The-Best-Animal-Health-Companies-In-India-For-Livestock-Management-thumbs-250X250.jpg" alt="img" />

                                        </a>
                                    </div>

                                    <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">
                                        <div className="event-info">
                                            <h4 className="title_h4"><a href="https://www.ukgermanpharmaceuticals.com/blog/how-to-choose-the-best-animal-health-companies-in-india-for-livestock-management.htm" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">How To Choose The Best Animal Health Companies In India For Livestock Management?</a></h4>

                                            <p className='lineClamp4'>Choosing the appropriate animal health company for livestock management is important for the health and productivity of your animals. India has a </p>


                                            <a className="event-btn" href="/blogCardDetail" title="Read More">Read More<i className="fa fa-long-arrow-right events-btn-icon"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 events-full-box">
                            <div className="events-single-box">
                                <div className="row">
                                    <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                        <a href="/blogCardDetail" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">
                                            <img className="img-responsive" src="https://www.ukgermanpharmaceuticals.com/uploaded-files/blog/images/thumbs/How-To-Choose-The-Best-Animal-Health-Companies-In-India-For-Livestock-Management-thumbs-250X250.jpg" alt="img" />

                                        </a>
                                    </div>

                                    <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">
                                        <div className="event-info">
                                            <h4 className="title_h4"><a href="https://www.ukgermanpharmaceuticals.com/blog/how-to-choose-the-best-animal-health-companies-in-india-for-livestock-management.htm" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">How To Choose The Best Animal Health Companies In India For Livestock Management?</a></h4>

                                            <p className='lineClamp4'>Choosing the appropriate animal health company for livestock management is important for the health and productivity of your animals. India has a </p>


                                            <a className="event-btn" href="/blogCardDetail" title="Read More">Read More<i className="fa fa-long-arrow-right events-btn-icon"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 events-full-box">
                            <div className="events-single-box">
                                <div className="row">
                                    <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                        <a href="/blogCardDetail" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">
                                            <img className="img-responsive" src="https://www.ukgermanpharmaceuticals.com/uploaded-files/blog/images/thumbs/How-To-Choose-The-Best-Animal-Health-Companies-In-India-For-Livestock-Management-thumbs-250X250.jpg" alt="img" />

                                        </a>
                                    </div>

                                    <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">
                                        <div className="event-info">
                                            <h4 className="title_h4"><a href="https://www.ukgermanpharmaceuticals.com/blog/how-to-choose-the-best-animal-health-companies-in-india-for-livestock-management.htm" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">How To Choose The Best Animal Health Companies In India For Livestock Management?</a></h4>

                                            <p className='lineClamp4'>Choosing the appropriate animal health company for livestock management is important for the health and productivity of your animals. India has a </p>


                                            <a className="event-btn" href="/blogCardDetail" title="Read More">Read More<i className="fa fa-long-arrow-right events-btn-icon"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 events-full-box">
                            <div className="events-single-box">
                                <div className="row">
                                    <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12">
                                        <a href="/blogCardDetail" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">
                                            <img className="img-responsive" src="https://www.ukgermanpharmaceuticals.com/uploaded-files/blog/images/thumbs/How-To-Choose-The-Best-Animal-Health-Companies-In-India-For-Livestock-Management-thumbs-250X250.jpg" alt="img" />

                                        </a>
                                    </div>

                                    <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-sm-12 col-12">
                                        <div className="event-info">
                                            <h4 className="title_h4"><a href="https://www.ukgermanpharmaceuticals.com/blog/how-to-choose-the-best-animal-health-companies-in-india-for-livestock-management.htm" title="How To Choose The Best Animal Health Companies In India For Livestock Management?">How To Choose The Best Animal Health Companies In India For Livestock Management?</a></h4>

                                            <p className='lineClamp4'>Choosing the appropriate animal health company for livestock management is important for the health and productivity of your animals. India has a </p>


                                            <a className="event-btn" href="/blogCardDetail" title="Read More">Read More<i className="fa fa-long-arrow-right events-btn-icon"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
            <div className="footer-wrapper">
                <Footer />
            </div>
        </div>
    )
}

export default Blogs
